import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/sitzmaa'
      className='link footer__link'
    >
      Thanks for visiting
    </a>
  </footer>
)

export default Footer
